import { gql } from "@apollo/client";
import { client } from "graphql/client";
import { DspScanInfoDetailType } from "../queries/getDspScanInfoDetail";

export const SUBMIT_DSP_RECEIVING_SORTING_REVIEW = gql`
  mutation SubmitDspReceivingSortingReview($parcelList: [DspScanInfoDetailInput!]!, $operatorName: String) {
    result: submitDspReceivingSortingReview(parcelList: $parcelList, operatorName: $operatorName) {
        success
    }
  }
`;


interface SubmitDspReceivingSortingReviewResponse {
    result: {
        success: boolean;
    };
}

export const handleSubmitDspReceivingSortingReview = async (parcelList: DspScanInfoDetailType[], operatorName?: string | null): Promise<boolean> => {
    // 移除 __typename 字段，避免 GraphQL 输入类型错误
    const cleanedParcelList = parcelList.map(parcel => {
        const { __typename, ...cleanedParcel } = parcel as DspScanInfoDetailType & { __typename?: string };
        return cleanedParcel;
    });

    const { data } = await client.mutate<SubmitDspReceivingSortingReviewResponse>({
        mutation: SUBMIT_DSP_RECEIVING_SORTING_REVIEW,
        variables: { 
            parcelList: cleanedParcelList,
            operatorName: operatorName || null
        }
    });
    return data?.result?.success || false;
};